import React from "react";

const Image = (props: any) => {
    return (
        <img
            {...props}
            onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = "/static/ic_user.png";
            }}
        />
    );
};

export default Image;
